mutation DeleteSavedFilter($input: FilterDeleteInput!) {
    filterDelete(input: $input) {
        filter {
            id
            isShared
        }
    }
}
